<template>
  <div>
    <div class="buttons">
      <router-link :to="{path: '/h/searchHistory'}" class="back">
        <vk-icon icon="triangle-left" ratio="2"></vk-icon>
      </router-link>
      <span v-if="total!==null">({{ total }}件)</span>
      <span>{{ searchText }}</span>
    </div>
    <div class="items" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="1000">
      <ItemsItem v-for="item in items" v-bind="item" :key="item.id"></ItemsItem>
    </div>
    <div v-if="items.length === 0 && !loading" class="information">
      検索に当てはまる対象がありませんでした。
    </div>
    <div v-if="!loading" class="text-center mt-2 mb-2">
      <button class="btn btn-danger" @click="$router.push({path: './contribution'})">希望のデザインがないのでリクエストする</button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import ItemsItem from './items/Item';
  export default {
    name: 'SearchResult',
    components: {ItemsItem},
    data() {
      return {
        items: [],
        total: null,
        item_next_page_url: 'http://admin.harigu.com/api/items/search/',
        searchText: '',
        searchWords: []
      };
    },
    created () {
      this.initialize();
      this.fetch();
    },
    computed: {
      loading () {
        return this.$store.state.loading;
      }
    },
    methods: {
      initialize: function () {
        if (!this.$route.params.searchText) {
          this.$router.push({name: 'searchHistory'});
          return;
        }
        this.items = [];
        this.searchText = this.$route.params.searchText;
        this.item_next_page_url = 'http://admin.harigu.com/api/items/search/';
        this.item_next_page_url += this.searchText;
        let searchWords = localStorage.getItem('searchWords');
        this.searchWords = searchWords ? JSON.parse(searchWords) : [];
      },
      async fetch () {
        if (!this.item_next_page_url) return;
        this.$store.commit('setLoading');
        let url = this.item_next_page_url;
        let response = await axios.get(url, {data: null});
        this.items = this.items.concat(response.data.data);
        this.total = response.data.total;
        this.item_next_page_url = response.data.next_page_url;
        this.pushHistory();
        this.$store.commit('resetLoading');
      },
      pushHistory: function () {
        // 検索履歴
        const existSearchWords = this.searchWords.filter(searchWord => {
          return searchWord[0] === this.searchText;
        });
        if (!existSearchWords.length) {
          this.searchWords.push([this.searchText, this.items.length]);
        } else {
          this.searchWords.splice(
            this.searchWords.indexOf(existSearchWords.shift()),
            1,
            [this.searchText, this.items.length]
          );
        }
        localStorage.setItem('searchWords', JSON.stringify(this.searchWords.slice(0, 30)));
      },
      loadMore: function () {
        this.busy = true;
        setTimeout(() => {
          this.fetch();
          this.busy = false;
        }, 1000);
      }
    },
    watch: {
      '$route' () {
        this.initialize();
        this.fetch();
      }
    }
  }
</script>

<style scoped lang="scss">
  .buttons {
    position: sticky;
    top: 48px;
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    z-index: 1;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
    &:after {
      clear: both;
    }
  }

  .items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .information {
    padding: 4rem 1rem;
  }
</style>
